import { authRoles } from 'app/auth';
import PredictionTypeEditForm from './editform/PredictionTypeEditForm';
import PredictionTypeTable from './table/PredictionTypeTable';

export default [
	{
		path: '/prediction-type/edit/:id',
		component: PredictionTypeEditForm,
		auth: authRoles.predictionType
	},
	{
		path: '/prediction-type/:sessionNameParam?',
		component: PredictionTypeTable,
		auth: authRoles.predictionType
	}
];
